<template>
    <div>
        <div id="cargando"
             wire:loading
             v-if="cargando"
             class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
            <div class="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta pagina.
            </p>
        </div>
        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="card-title-style"> Redirect </v-card-title>
            <v-form ref="form" lazy-validation>
                <v-card-text>
                    <v-row justify="center" v-if="loaded == false">
                        <v-col cols="12" md="7">
                            <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"></v-skeleton-loader>
                        </v-col>
                    </v-row>

                </v-card-text>
            </v-form>
        </v-card>
    </div>
</template>
<script>
    import { mapState, mapMutations, mapGetters } from "vuex";
    import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
    import General from '@/services/ReporteGeneral/ReporteGeneral.service.js';

    export default {
        props: ["tokenData"],
        data() {
            return {
                validForm: true,
                respuestaText: "SI",
                encabezadoText: [],
                loaded: false,

                dateCollabsable: false,
                dateComponentConstraints: {},
                cargando: true,
            };
        },
        computed: {
            ...mapState({ drawer: state => state.drawer }),
            ...mapState(['domain', 'informationPage']),
            DRAWER_STATE: {
                get() {
                    return this.drawer
                },
            }
        },
        mounted() {
            this.getDatosGenerales();
        },
        methods: {
            ...mapMutations(["changeReporteMenuOption"]),
            async getDatosGenerales() {

                var str = this.tokenData.toString();

                var dataArray = [];
                await General.Desencriptar(this, str).then(data => {
                    console.log(data);
                    dataArray = data;
                    
                });
                //if (dataArray.svfhconclusion == undefined)
                //    dataArray.svfhconclusion = '';

                let reporte = dataArray;//{
                //    nrreporte: String(dataArray.nrreporte),
                //    svindice: String(dataArray.indice),
                //    aiclave: String(dataArray.aiclave),
                //    svfhconclusion: dataArray.svfhconclusion,
                //    psid: dataArray.psid
                //};

                console.log(reporte);
                MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');

                this.$router.push({ name: reporte.routername });
                //let data = new FormData();
                //data.append("data", JSON.stringify(reporte));
                //data.append("indice", reporte.svindice);
                //data.append("psid", reporte.psid);

                //await General.Autorizado(this, data).then(data => {
                    
                //    if (data == false) {
                //        MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');

                //        switch (reporte.aiclave.toString()) {
                //            case "1":
                //                this.$router.push({ name: `AutorizarPagoExpJur` });
                //                break;
                //            case "24":
                //                this.$router.push({ name: `AutorizarPagoRobo` });
                //                break;
                //            case "23":
                //                this.$router.push({ name: `AutorizarPagoRLV` });
                //                break;
                //            case "5":
                //                this.$router.push({ name: `AutorizarPagoRCMedico` });
                //                break;
                //        }
                //    }
                //    else {
                //        this.cargando = false;
                //        this.$swal(
                //            "Atención",
                //            "La Presolicitud ya ha sido atendida",
                //            "warning"
                //        );
                //        this.$router.push({ name: 'index' });
                //    }
                //});

                
                
            }


        },
        watch: {

        },
    };
</script>